import { Button, Box, Typography, Grid, ButtonGroup } from "@mui/material";
import { FilterType, FileOptionTypes } from "../../../utilities/types";

interface GlobalGeoTypeSelectorProps {
	onApplyToPolygons: (type: FilterType) => void;
	onApplyToPoints: (type: FilterType) => void;
	hasPolygonData: boolean;
	hasPointData: boolean;
}

export default function GlobalGeoTypeSelector({
	onApplyToPolygons,
	onApplyToPoints,
	hasPolygonData,
	hasPointData,
}: GlobalGeoTypeSelectorProps) {
	return (
		<Box sx={{ mb: 3, p: 2, backgroundColor: "background.paper" }}>
			<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
				If all of your data is of the same type, you can apply the same selection to all groups at once.
			</Typography>
			<Grid container spacing={3}>
				{hasPolygonData && (
					<Grid item xs={12} md={6}>
						<Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
							Polygons
						</Typography>
						<ButtonGroup variant="outlined" fullWidth>
							<Button onClick={() => onApplyToPolygons("Boundary")} size="large">
								{FileOptionTypes.Boundary.label}
							</Button>
							<Button onClick={() => onApplyToPolygons("Zones")} size="large">
								{FileOptionTypes.Zones.label}
							</Button>
						</ButtonGroup>
					</Grid>
				)}
				{hasPointData && (
					<Grid item xs={12} md={6}>
						<Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
							Points
						</Typography>
						<ButtonGroup variant="outlined" fullWidth>
							<Button onClick={() => onApplyToPoints("Centroids")} size="large">
								{FileOptionTypes.Centroids.label}
							</Button>
							<Button onClick={() => onApplyToPoints("Cores")} size="large">
								{FileOptionTypes.Cores.label}
							</Button>
						</ButtonGroup>
					</Grid>
				)}
			</Grid>
		</Box>
	);
}
